import React from 'react';
import { Text, Conditional } from '@cashfree-intl/coherent';
import { roundOffNumber } from 'utils/common';
import { MarkupTable, StyledForexCalculator, TableWrapper } from '../styled';
import { FOREX_MARKUP_BREAKDOWN } from './constants';

const ForexMarkupDetails = ({
  forexCalculation,
  forexMarkup,
  isForexMarkupEnabled,
}: {
  forexMarkup: number;
  isForexMarkupEnabled: boolean;
  forexCalculation: any;
}) => (
  <div className="mt-3">
    <StyledForexCalculator alignItems="flex-start" gap={4.5}>
      <TableWrapper>
        <MarkupTable>
          <thead>
            <tr>
              <th />
              <th>
                <Text variant="b12">Without Markup</Text>
              </th>
              <th>
                <Conditional if={isForexMarkupEnabled}>
                  <Text variant="b12">With Markup</Text>
                </Conditional>
                <Conditional if={!isForexMarkupEnabled}>
                  <Text variant="b12">
                    With Assumed Markup of {roundOffNumber(forexMarkup)}%
                  </Text>
                </Conditional>
              </th>
            </tr>
          </thead>
          <tbody>
            {FOREX_MARKUP_BREAKDOWN.map((obj, index) => (
              <tr key={obj.key}>
                <td>{obj.label}</td>
                <td>
                  {forexCalculation[obj.key].withoutMarkup}
                  {index === FOREX_MARKUP_BREAKDOWN.length - 1 ? '%' : ''}
                </td>
                <td>
                  {forexCalculation[obj.key].withMarkup}
                  {index === FOREX_MARKUP_BREAKDOWN.length - 1 ? '%' : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </MarkupTable>
      </TableWrapper>
    </StyledForexCalculator>
  </div>
);

export default ForexMarkupDetails;
